import { API_ENDPOINT, API_MAIN_KVS } from "@iso/config/index";
import { axiosClient } from "@iso/helpers/axios.config";

const storeApi = {
   getStoresByUserId: (userId) => {
      return axiosClient.get(`${API_ENDPOINT}/api/identity/users/${userId}/stores`);
   },
};

export default storeApi;